import { useStaticQuery, graphql } from 'gatsby'
export const useInteriorAccordionQuery = () => {
  const { wp } = useStaticQuery(graphql`
    query InteriorAccordionQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            interiorPage {
              accordion {
                accordionArrow {
                  sourceUrl
                }
                defaultAccordionImage {
                  sourceUrl
                }
              }
            }
          }
        }
      }
    }
  `)

  return wp.acfOptionsCommonItems.commonItems.interiorPage.accordion
}
